import { Badge, Body1, BrandGraphic, Card, Title3, XStack, YStack } from "@medbillai/ui";
import { OnboardingScreen } from "../../components/OnboardingScreen";
import { type OnDone, tagged } from "../../lib/flow-engine";
import { LogoWall } from "./LogoWall";
import type { OnboardingPartner } from "./types";
export type FaResultStrongCaseOutcomes = {
  continue: {};
};
const Outcome = tagged<FaResultStrongCaseOutcomes>();
export function FaResultStrongCase({
  onDone,
  partner
}: {
  onDone: OnDone<FaResultStrongCaseOutcomes>;
  partner: OnboardingPartner | null;
}) {
  return <OnboardingScreen data-sentry-element="OnboardingScreen" data-sentry-component="FaResultStrongCase" data-sentry-source-file="FaResultStrongCase.tsx">
      <OnboardingScreen.Nav data-sentry-element="OnboardingScreen.Nav" data-sentry-source-file="FaResultStrongCase.tsx" />
      <OnboardingScreen.Content data-sentry-element="OnboardingScreen.Content" data-sentry-source-file="FaResultStrongCase.tsx">
        <OnboardingScreen.Header alignment="left" title="We have good news for you!" subtitle="You're likely to qualify for significant discounts on medical bills from hospitals near you." data-sentry-element="OnboardingScreen.Header" data-sentry-source-file="FaResultStrongCase.tsx" />
        <Card variant="elevated" size="large" data-sentry-element="Card" data-sentry-source-file="FaResultStrongCase.tsx">
          <YStack gap="$sp2" data-sentry-element="YStack" data-sentry-source-file="FaResultStrongCase.tsx">
            <XStack justifyContent="space-between" alignItems="flex-start" gap="$sp2" data-sentry-element="XStack" data-sentry-source-file="FaResultStrongCase.tsx">
              <YStack gap="$sp1" alignItems="flex-start" flexShrink={1} data-sentry-element="YStack" data-sentry-source-file="FaResultStrongCase.tsx">
                <Badge status="positive" size="small" data-sentry-element="Badge" data-sentry-source-file="FaResultStrongCase.tsx">
                  Estimate based on your profile
                </Badge>
                <Title3 data-sentry-element="Title3" data-sentry-source-file="FaResultStrongCase.tsx">Likely to qualify</Title3>
              </YStack>
              <BrandGraphic type="bill" indicator="dollar" size="$si7" data-sentry-element="BrandGraphic" data-sentry-source-file="FaResultStrongCase.tsx" />
            </XStack>
            <Body1 color="$textSubtle" data-sentry-element="Body1" data-sentry-source-file="FaResultStrongCase.tsx">
              This is an estimate based on your family size and household
              income.
            </Body1>
            {partner ? <Body1 color="$textSubtle">
                You're exempt from any Granted success fees as part of your
                benefits package
              </Body1> : null}
          </YStack>
        </Card>
        <YStack paddingTop="$sp4" data-sentry-element="YStack" data-sentry-source-file="FaResultStrongCase.tsx">
          <LogoWall testID="fa-result-strong-case.hospital-logos" src={{
          web: "/static/onboarding/fa-result-hospitals.png",
          native: require("../../assets/onboarding/fa-result-hospitals.png")
        }} alt="Hospitals we help patients with" data-sentry-element="LogoWall" data-sentry-source-file="FaResultStrongCase.tsx" />
        </YStack>
      </OnboardingScreen.Content>
      <OnboardingScreen.Footer data-sentry-element="OnboardingScreen.Footer" data-sentry-source-file="FaResultStrongCase.tsx">
        <OnboardingScreen.PrimaryAction testID="fa-result-strong-case.activate" variant="brand" onPress={() => onDone(Outcome.continue())} data-sentry-element="OnboardingScreen.PrimaryAction" data-sentry-source-file="FaResultStrongCase.tsx">
          Continue
        </OnboardingScreen.PrimaryAction>
      </OnboardingScreen.Footer>
    </OnboardingScreen>;
}